'use client';

import React, { useMemo } from 'react';

import type { SearchCommonPageData } from '@/app/components/search/SearchMain.tsx';

export const SearchCommonPageContext = React.createContext<SearchCommonPageData>({} as SearchCommonPageData);

export default function SearchCommonPageDataProvider({
  searchCommonPageData,
  children,
}: {
  searchCommonPageData: SearchCommonPageData;
  children: React.ReactNode;
}) {
  const contextValue = useMemo(() => searchCommonPageData, [searchCommonPageData]);
  return <SearchCommonPageContext.Provider value={contextValue}>{children}</SearchCommonPageContext.Provider>;
}

export const useSearchCommonPageData = () => React.useContext(SearchCommonPageContext);
